import { IEntityDetails } from '../types';

export const DEFAULT_LOADING_ROWS_FOR_PARENT_PANEL = 10;
export const DEFAULT_LOADING_ROWS_FOR_LEVEL_THREE = 7;
export const DEFAULT_HEADER_ERROR_MESSAGE = "We're having an issue loading sections";
export const DEFAULT_ERROR_MESSAGE = 'Try again or contact support if the problem persists.';

/**
 *
 * @param handler
 *
 * On mobile devices, clicking on the element that opens a submenu does not reliably
 * close the submenu. This function is a workaround to ensure that the submenu closes
 * by delaying the click event callback by 100ms to prevent race conditions between the click
 * and the submenu open/close logic.
 */
export const delayedMobileCloseClickHandler = (handler: () => void) => {
  setTimeout(handler, 100);
};

type GetInactiveEntitiesArgs = {
  activeEntity: IEntityDetails;
  entitledEntities: IEntityDetails[];
  limit?: number;
};
/**
 * Retrieves the inactive entities based on the active entity and entitled entities.
 * @param activeEntity - The active entity.
 * @param entitledEntities - The entitled entities.
 * @param limit - The maximum number of inactive entities to retrieve (optional).
 * @returns The inactive entities
 * @throws If the limit is less than 1.
 */
export const getInactiveEntities = ({
  activeEntity,
  entitledEntities,
  limit
}: GetInactiveEntitiesArgs): IEntityDetails[] => {
  const inactiveEntities = entitledEntities?.filter((entity) => entity.id !== activeEntity?.id) || [];

  if (typeof limit === 'number') {
    if (limit < 1) {
      throw new Error('Limit must be greater than 0');
    } else {
      return inactiveEntities.slice(0, limit);
    }
  }

  return inactiveEntities;
};
